module.exports = __webpack_public_path__ + "media/assets/svgs/close-dark-463c3c7659854906923306b0136dcbf3.svg";